import { allFilms } from "./allFilms";

export const fifteenFilms = allFilms.filter(function(obj) { return obj.type === '15 anos'; });

